<template>
  <div>
    <vxe-grid
      ref="xTable"
      highlight-hover-row
      :data="tableData"
      :height="tableHeight"
      :columns="tableColumns"
      row-key
      size="mini"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"> </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-link type="danger" @click="delRow(row)">删除</el-link>
        </div>
      </template>
      <template v-slot:content="{ row }">
        <table-point
          ref="tablePoint"
          :lineCode="row.lineCode"
          @openEditPointDialog="openEditPointDialog"
        />
      </template>
    </vxe-grid>
  </div>
</template>
<script>
export default {
  props: {
    code: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      params: {},
      tableHeight: 230,
      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          type: 'expand',
          width: 30,
          slots: {
            content: 'content',
          },
        },
        {
          title: '货物名称',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'left',
          width: '100',
          field: 'goodsName',
        },
        {
          title: '货物代码',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'left',
          width: '80',
          field: 'goodsNo',
        },
        {
          title: '货物类型',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '80',
          field: 'goodsTypeName',
        },
        {
          title: '包装类型',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '80',
          field: 'packageTypeName',
        },
        {
          title: '拆成件数',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '70',
          field: 'goodsQty',
        },
        {
          title: '支出重量kg',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '90',
          field: 'factWeight',
        },
        {
          title: '支出体积m³',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '90',
          field: 'factVolume',
        },
        {
          title: '备注说明',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'left',
          width: '100',
          field: 'goodsRemarks',
        },
        {
          title: '收入重量kg',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '90',
          field: 'goodsWeight',
        },
        {
          title: '收入体积m³',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '90',
          field: 'goodsVolume',
        },
        {
          title: '货值',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '90',
          field: 'goodsValue',
        },
      ],
      tableData: [],
      formData: {
        orderCode: this.code,
      },
    }
  },
  created() {},
  watch: {},
  computed: {
    // totQty() {
    //   let count = 0
    //   this.tableData.forEach((item) => {
    //     count += Number(item['goodsQty'])
    //   })
    //   return count
    // },
    // totInWeight() {
    //   let count = 0
    //   this.tableData.forEach((item) => {
    //     count += Number(item['goodsWeight'])
    //   })
    //   return count
    // },
    // totInVolume() {
    //   let count = 0
    //   this.tableData.forEach((item) => {
    //     count += Number(item['goodsVolume'])
    //   })
    //   return count
    // },
    // totPayWeight() {
    //   let count = 0
    //   this.tableData.forEach((item) => {
    //     count += Number(item['factWeight'])
    //   })
    //   return count
    // },
    // totPayVolume() {
    //   let count = 0
    //   this.tableData.forEach((item) => {
    //     count += Number(item['factVolume'])
    //   })
    //   return count
    // },
    // totValue() {
    //   let count = 0
    //   this.tableData.forEach((item) => {
    //     count += Number(item['goodsValue'])
    //   })
    //   return count
    // },
  },
  methods: {
    // reset() {
    //   this.formData = {}
    //   this.tableData = []
    // },
    // fromLoad(ref, row = {}) {
    //   if (ref === 'edit') {
    //     // 获取当前记录在记录集中的唯一索引
    //     let index = this.$refs.xTable.getRowIndex(row)
    //     this.$refs.goodsEdit.load(ref, { ...row, index: index })
    //     return
    //   }
    //   this.$refs.goodsEdit.load(ref, { ...row })
    // },
    // addRowSave(rowData) {
    //   this.tableData.push(rowData)
    // },
    // editRowSave(rowData) {
    //   for (let i = 0; i < this.tableData.length; i++) {
    //     if (i === rowData.index) {
    //       this.$set(this.tableData, i, rowData)
    //     }
    //   }
    // },
    // delSelectRow() {
    //   const selectRecords = this.$refs.xTable.getCheckboxRecords()
    //   if (selectRecords.length < 1) {
    //     this.$message({
    //       showClose: true,
    //       message: '请选择需要删除的数据',
    //       type: 'warning',
    //     })
    //     return
    //   }
    //   this.$XModal.confirm('您确定要删除所勾选数据吗?').then((type) => {
    //     if (type === 'confirm') {
    //       this.$refs.xTable.removeCheckboxRow()
    //       selectRecords.forEach((item) => {
    //         let _XID = item._XID
    //         this.tableData.forEach((row, index) => {
    //           if (row._XID === _XID) {
    //             this.tableData.splice(index, 1)
    //           }
    //         })
    //       })
    //     }
    //   })
    // },
    // delRow(row) {
    //   this.$XModal.confirm('您确定要删除该数据吗?').then((type) => {
    //     if (type === 'confirm') {
    //       let index = this.$refs.xTable.getRowIndex(row)
    //       this.tableData.splice(index, 1)
    //     }
    //   })
    // },
    // getGoodsData() {
    //   if (this.tableData.length < 1) {
    //     this.$message.error('订单货物信息未填写，请检查')
    //     return
    //   }
    //   this.formData.totQty = this.totQty
    //   this.formData.totInWeight = this.totInWeight
    //   this.formData.totInVolume = this.totInVolume
    //   this.formData.totPayWeight = this.totPayWeight
    //   this.formData.totPayVolume = this.totPayVolume
    //   this.formData.totValue = this.totValue
    //   this.formData.goodsList = this.tableData
    //   return this.formData
    // },
  },
}
</script>
